import Modal from "@/src/common/components/Modal"
import {
  RequestProfileUpdateModal,
  SuccessModal
} from "@/src/sb/components/auth/ProfileUpdate"
import { useSession } from "next-auth/react"
import { useState } from "react"

import ProfileUpdateForm from "./ProfileUpdateForm"

type ProfileUpdateModalProps = {
  onClose?: () => void
}

const ProfileUpdateModal = ({ onClose }: ProfileUpdateModalProps) => {
  const [showRequestProfileUpdateModal, setShowRequestProfileUpdateModal] =
    useState(false)
  const [showSuccessModal, setShowSuccessModal] = useState(false)
  const [showProfileUpdateFormModal, setShowProfileUpdateFormModal] =
    useState(false)

  const { update } = useSession()

  const handleCloseModal = () => {
    setShowRequestProfileUpdateModal(false)
    setShowSuccessModal(false)
    setShowProfileUpdateFormModal(false)
    if (onClose) onClose()
  }

  return (
    <>
      {showRequestProfileUpdateModal ? (
        <RequestProfileUpdateModal
          onClose={handleCloseModal}
          onUpdateProfile={() => {
            setShowRequestProfileUpdateModal(false)
            setShowProfileUpdateFormModal(true)
          }}
        />
      ) : null}

      {showSuccessModal ? (
        <SuccessModal
          onClose={async () => {
            setShowSuccessModal(false)
            await update()
          }}
        />
      ) : null}

      {showProfileUpdateFormModal ? (
        <Modal onClose={onClose} className="md:max-w-[640px]">
          <ProfileUpdateForm
            type={"existing_user"}
            onSuccess={() => {
              setShowProfileUpdateFormModal(false)
              setShowSuccessModal(true)
            }}
          />
        </Modal>
      ) : null}
    </>
  )
}

export default ProfileUpdateModal
